import React  from 'react';
import classes from "./RankDivBtn.module.css";
import joinBtnImg from "../../../assets/Game/chartbtn/join.png";
import repairBtnImg from "../../../assets/Game/chartbtn/repair.png";
import resettBtnImg from "../../../assets/Game/reset.png";
import rank1 from "../../../assets/Game/bars/cb1.png";
import rank2 from "../../../assets/Game/bars/cb2.png";
import rank3 from "../../../assets/Game/bars/cb3.png";
import rank4 from "../../../assets/Game/bars/cb4.png";
import rank5 from "../../../assets/Game/bars/cb5.png";


interface currentMeshType {
  joinBtn: () => void;
  repairBtn: () => void;
  collectBtn : () => void;
  matchesWon : number;
};

const RankDivBtn:React.FC<currentMeshType> = ({ matchesWon, joinBtn, repairBtn, collectBtn}) => {
    //matching rank to appropriate img
  let rankImg = rank1
  let rank = "Private"

  if (matchesWon >= 100) {
    rankImg =  rank2
    rank = 'Sergeant'
  }
  if (matchesWon >= 200) {
    rankImg =  rank3
    rank = 'Captain'
  }
  if (matchesWon >= 300) {
    rankImg =  rank4
    rank = 'Major'
  }
  if (matchesWon >= 400) {
    rankImg = rank5
    rank = 'General'
  }
    
  return (
    <div className={classes["match-won-div"]}>
        
      <div className={classes["battle-rank-div"]}>
        <div>{matchesWon}/400</div>
        <div>{rank}</div>
        <div>
          <img src={rankImg} alt="rank" />
        </div>
      </div>

      <div className={classes["btn-div"]}>
            
        <img onClick={joinBtn}  className={classes["btn-img"]} src={joinBtnImg} alt="" />
        <img onClick={repairBtn} className={classes["btn-img"]} src={repairBtnImg} alt="" />
        <img onClick={collectBtn} className={classes["btn-img"]} src={resettBtnImg} alt="" />
      </div>
    </div>
  );
}

export default RankDivBtn